module.exports = __webpack_public_path__ + "static/metal03-2edd24798c7c006c128264c55b4e2ad7.png";